/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrganizationNameIndexRouteImport } from './routes/$organizationName/index'
import { Route as InvestigationsInvestigationIdRouteImport } from './routes/investigations/$investigationId'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as OrganizationNameUsageRouteImport } from './routes/$organizationName/usage'
import { Route as OrganizationNameMcpRouteImport } from './routes/$organizationName/mcp'
import { Route as OrganizationNameLibraryRouteImport } from './routes/$organizationName/library'
import { Route as OrganizationNameAboutYouRouteImport } from './routes/$organizationName/about-you'
import { Route as OrganizationNameSettingsRouteRouteImport } from './routes/$organizationName/settings/route'
import { Route as OrganizationNameOrgDocsRouteRouteImport } from './routes/$organizationName/org-docs/route'
import { Route as OrganizationNameInvestigationsRouteRouteImport } from './routes/$organizationName/investigations/route'
import { Route as OrganizationNameDashboardRouteRouteImport } from './routes/$organizationName/_dashboard/route'
import { Route as OrganizationNameSettingsIndexRouteImport } from './routes/$organizationName/settings/index'
import { Route as OrganizationNameOrgDocsIndexRouteImport } from './routes/$organizationName/org-docs/index'
import { Route as OrganizationNameInvestigationsIndexRouteImport } from './routes/$organizationName/investigations/index'
import { Route as OrganizationNameSettingsWorkspaceRouteImport } from './routes/$organizationName/settings/workspace'
import { Route as OrganizationNameSettingsUsageRouteImport } from './routes/$organizationName/settings/usage'
import { Route as OrganizationNameSettingsSsoScimRouteImport } from './routes/$organizationName/settings/sso-scim'
import { Route as OrganizationNameSettingsOrganizationRouteImport } from './routes/$organizationName/settings/organization'
import { Route as OrganizationNameSettingsLabsRouteImport } from './routes/$organizationName/settings/labs'
import { Route as OrganizationNameSettingsByomRouteImport } from './routes/$organizationName/settings/byom'
import { Route as OrganizationNameSettingsBillingRouteImport } from './routes/$organizationName/settings/billing'
import { Route as OrganizationNameSettingsAgentcoreRouteImport } from './routes/$organizationName/settings/agentcore'
import { Route as OrganizationNameSettingsAccountRouteImport } from './routes/$organizationName/settings/account'
import { Route as OrganizationNameSettingsAccessRouteImport } from './routes/$organizationName/settings/_access'
import { Route as OrganizationNameOrgDocsPageVersionNodeIdRouteImport } from './routes/$organizationName/org-docs/$pageVersionNodeId'
import { Route as OrganizationNameInvestigationsNewRouteImport } from './routes/$organizationName/investigations/new'
import { Route as OrganizationNameInvestigationsInvestigationIdRouteImport } from './routes/$organizationName/investigations/$investigationId'
import { Route as OrganizationNameDashboardSourcesRouteImport } from './routes/$organizationName/_dashboard/sources'
import { Route as OrganizationNameDashboardBranchesRouteImport } from './routes/$organizationName/_dashboard/branches'
import { Route as OrganizationNameSettingsMachinesRouteRouteImport } from './routes/$organizationName/settings/machines/route'
import { Route as OrganizationNameSettingsAnalyticsRouteRouteImport } from './routes/$organizationName/settings/analytics/route'
import { Route as OrganizationNameSettingsAccessTokensRouteRouteImport } from './routes/$organizationName/settings/access-tokens/route'
import { Route as OrganizationNamePdfPdfVersionNodeIdRouteRouteImport } from './routes/$organizationName/pdf/$pdfVersionNodeId/route'
import { Route as OrganizationNameCbCodebaseIdRouteRouteImport } from './routes/$organizationName/cb/$codebaseId/route'
import { Route as OrganizationNameDashboardAnalyticsRouteRouteImport } from './routes/$organizationName/_dashboard/analytics/route'
import { Route as OrganizationNameSettingsMachinesIndexRouteImport } from './routes/$organizationName/settings/machines/index'
import { Route as OrganizationNameSettingsIntegrationsIndexRouteImport } from './routes/$organizationName/settings/integrations/index'
import { Route as OrganizationNamePdfPdfVersionNodeIdIndexRouteImport } from './routes/$organizationName/pdf/$pdfVersionNodeId/index'
import { Route as OrganizationNameSettingsIntegrationsAgentConnectionsRouteImport } from './routes/$organizationName/settings/integrations/agent-connections'
import { Route as OrganizationNameSettingsIntegrationsIntegrationTypeRouteImport } from './routes/$organizationName/settings/integrations/$integrationType'
import { Route as OrganizationNameCbCodebaseIdBranchesRouteImport } from './routes/$organizationName/cb/$codebaseId/branches'
import { Route as OrganizationNameSettingsAccessUsersRouteRouteImport } from './routes/$organizationName/settings/_access/users/route'
import { Route as OrganizationNameSettingsAccessTeamsRouteRouteImport } from './routes/$organizationName/settings/_access/teams/route'
import { Route as OrganizationNameSettingsAccessSourcesRouteRouteImport } from './routes/$organizationName/settings/_access/sources/route'
import { Route as OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteImport } from './routes/$organizationName/pdf/$pdfVersionNodeId/settings/route'
import { Route as OrganizationNameCbCodebaseIdSettingsRouteRouteImport } from './routes/$organizationName/cb/$codebaseId/settings/route'
import { Route as OrganizationNameSettingsMachinesMachineIdIndexRouteImport } from './routes/$organizationName/settings/machines/$machineId/index'
import { Route as OrganizationNameSettingsAnalyticsCodebaseIdIndexRouteImport } from './routes/$organizationName/settings/analytics/$codebaseId/index'
import { Route as OrganizationNameSettingsAccessUsersIndexRouteImport } from './routes/$organizationName/settings/_access/users/index'
import { Route as OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRouteImport } from './routes/$organizationName/pdf/$pdfVersionNodeId/autodocs/index'
import { Route as OrganizationNameCbCodebaseIdAutodocsIndexRouteImport } from './routes/$organizationName/cb/$codebaseId/autodocs/index'
import { Route as OrganizationNameCbCodebaseIdAtlasIndexRouteImport } from './routes/$organizationName/cb/$codebaseId/atlas/index'
import { Route as OrganizationNameDashboardAnalyticsCodebaseIdIndexRouteImport } from './routes/$organizationName/_dashboard/analytics/$codebaseId/index'
import { Route as OrganizationNameSettingsMachinesMachineIdTabRouteImport } from './routes/$organizationName/settings/machines/$machineId/$tab'
import { Route as OrganizationNameSettingsAnalyticsCodebaseIdTabRouteImport } from './routes/$organizationName/settings/analytics/$codebaseId/$tab'
import { Route as OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRouteImport } from './routes/$organizationName/pdf/$pdfVersionNodeId/settings/general'
import { Route as OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRouteImport } from './routes/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId'
import { Route as OrganizationNameCbCodebaseIdTreeSplatRouteImport } from './routes/$organizationName/cb/$codebaseId/tree/$'
import { Route as OrganizationNameCbCodebaseIdSettingsGeneralRouteImport } from './routes/$organizationName/cb/$codebaseId/settings/general'
import { Route as OrganizationNameCbCodebaseIdOverviewSplatRouteImport } from './routes/$organizationName/cb/$codebaseId/overview/$'
import { Route as OrganizationNameCbCodebaseIdCodeSplatRouteImport } from './routes/$organizationName/cb/$codebaseId/code/$'
import { Route as OrganizationNameCbCodebaseIdAutodocsAutodocIdRouteImport } from './routes/$organizationName/cb/$codebaseId/autodocs/$autodocId'
import { Route as OrganizationNameCbCodebaseIdAtlasSplatRouteImport } from './routes/$organizationName/cb/$codebaseId/atlas/$'
import { Route as OrganizationNameDashboardAnalyticsCodebaseIdTabRouteImport } from './routes/$organizationName/_dashboard/analytics/$codebaseId/$tab'
import { Route as OrganizationNameSettingsAccessUsersUserIdIndexRouteImport } from './routes/$organizationName/settings/_access/users/$userId/index'
import { Route as OrganizationNameSettingsAccessTeamsTeamIdIndexRouteImport } from './routes/$organizationName/settings/_access/teams/$teamId/index'
import { Route as OrganizationNameSettingsAccessSourcesSourceIdIndexRouteImport } from './routes/$organizationName/settings/_access/sources/$sourceId/index'
import { Route as OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRouteImport } from './routes/$organizationName/ws/$workspaceId/cb/$codebaseId/$'
import { Route as OrganizationNameSettingsAccessUsersUserIdTabRouteImport } from './routes/$organizationName/settings/_access/users/$userId/$tab'
import { Route as OrganizationNameSettingsAccessTeamsTeamIdTabRouteImport } from './routes/$organizationName/settings/_access/teams/$teamId/$tab'
import { Route as OrganizationNameSettingsAccessSourcesSourceIdBranchesRouteImport } from './routes/$organizationName/settings/_access/sources/$sourceId/branches'
import { Route as OrganizationNameSettingsAccessSourcesSourceIdTabRouteImport } from './routes/$organizationName/settings/_access/sources/$sourceId/$tab'
import { Route as OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRouteImport } from './routes/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId'
import { Route as OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRouteImport } from './routes/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationNameIndexRoute = OrganizationNameIndexRouteImport.update({
  id: '/$organizationName/',
  path: '/$organizationName/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvestigationsInvestigationIdRoute =
  InvestigationsInvestigationIdRouteImport.update({
    id: '/investigations/$investigationId',
    path: '/investigations/$investigationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const OrganizationNameUsageRoute = OrganizationNameUsageRouteImport.update({
  id: '/$organizationName/usage',
  path: '/$organizationName/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationNameMcpRoute = OrganizationNameMcpRouteImport.update({
  id: '/$organizationName/mcp',
  path: '/$organizationName/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationNameLibraryRoute = OrganizationNameLibraryRouteImport.update({
  id: '/$organizationName/library',
  path: '/$organizationName/library',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationNameAboutYouRoute =
  OrganizationNameAboutYouRouteImport.update({
    id: '/$organizationName/about-you',
    path: '/$organizationName/about-you',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameSettingsRouteRoute =
  OrganizationNameSettingsRouteRouteImport.update({
    id: '/$organizationName/settings',
    path: '/$organizationName/settings',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameOrgDocsRouteRoute =
  OrganizationNameOrgDocsRouteRouteImport.update({
    id: '/$organizationName/org-docs',
    path: '/$organizationName/org-docs',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameInvestigationsRouteRoute =
  OrganizationNameInvestigationsRouteRouteImport.update({
    id: '/$organizationName/investigations',
    path: '/$organizationName/investigations',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameDashboardRouteRoute =
  OrganizationNameDashboardRouteRouteImport.update({
    id: '/$organizationName/_dashboard',
    path: '/$organizationName',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameSettingsIndexRoute =
  OrganizationNameSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameOrgDocsIndexRoute =
  OrganizationNameOrgDocsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationNameOrgDocsRouteRoute,
  } as any)
const OrganizationNameInvestigationsIndexRoute =
  OrganizationNameInvestigationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationNameInvestigationsRouteRoute,
  } as any)
const OrganizationNameSettingsWorkspaceRoute =
  OrganizationNameSettingsWorkspaceRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsUsageRoute =
  OrganizationNameSettingsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsSsoScimRoute =
  OrganizationNameSettingsSsoScimRouteImport.update({
    id: '/sso-scim',
    path: '/sso-scim',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsOrganizationRoute =
  OrganizationNameSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsLabsRoute =
  OrganizationNameSettingsLabsRouteImport.update({
    id: '/labs',
    path: '/labs',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsByomRoute =
  OrganizationNameSettingsByomRouteImport.update({
    id: '/byom',
    path: '/byom',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsBillingRoute =
  OrganizationNameSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsAgentcoreRoute =
  OrganizationNameSettingsAgentcoreRouteImport.update({
    id: '/agentcore',
    path: '/agentcore',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsAccountRoute =
  OrganizationNameSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsAccessRoute =
  OrganizationNameSettingsAccessRouteImport.update({
    id: '/_access',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameOrgDocsPageVersionNodeIdRoute =
  OrganizationNameOrgDocsPageVersionNodeIdRouteImport.update({
    id: '/$pageVersionNodeId',
    path: '/$pageVersionNodeId',
    getParentRoute: () => OrganizationNameOrgDocsRouteRoute,
  } as any)
const OrganizationNameInvestigationsNewRoute =
  OrganizationNameInvestigationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => OrganizationNameInvestigationsRouteRoute,
  } as any)
const OrganizationNameInvestigationsInvestigationIdRoute =
  OrganizationNameInvestigationsInvestigationIdRouteImport.update({
    id: '/$investigationId',
    path: '/$investigationId',
    getParentRoute: () => OrganizationNameInvestigationsRouteRoute,
  } as any)
const OrganizationNameDashboardSourcesRoute =
  OrganizationNameDashboardSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => OrganizationNameDashboardRouteRoute,
  } as any)
const OrganizationNameDashboardBranchesRoute =
  OrganizationNameDashboardBranchesRouteImport.update({
    id: '/branches',
    path: '/branches',
    getParentRoute: () => OrganizationNameDashboardRouteRoute,
  } as any)
const OrganizationNameSettingsMachinesRouteRoute =
  OrganizationNameSettingsMachinesRouteRouteImport.update({
    id: '/machines',
    path: '/machines',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsAnalyticsRouteRoute =
  OrganizationNameSettingsAnalyticsRouteRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsAccessTokensRouteRoute =
  OrganizationNameSettingsAccessTokensRouteRouteImport.update({
    id: '/access-tokens',
    path: '/access-tokens',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNamePdfPdfVersionNodeIdRouteRoute =
  OrganizationNamePdfPdfVersionNodeIdRouteRouteImport.update({
    id: '/$organizationName/pdf/$pdfVersionNodeId',
    path: '/$organizationName/pdf/$pdfVersionNodeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameCbCodebaseIdRouteRoute =
  OrganizationNameCbCodebaseIdRouteRouteImport.update({
    id: '/$organizationName/cb/$codebaseId',
    path: '/$organizationName/cb/$codebaseId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameDashboardAnalyticsRouteRoute =
  OrganizationNameDashboardAnalyticsRouteRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => OrganizationNameDashboardRouteRoute,
  } as any)
const OrganizationNameSettingsMachinesIndexRoute =
  OrganizationNameSettingsMachinesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationNameSettingsMachinesRouteRoute,
  } as any)
const OrganizationNameSettingsIntegrationsIndexRoute =
  OrganizationNameSettingsIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNamePdfPdfVersionNodeIdIndexRoute =
  OrganizationNamePdfPdfVersionNodeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationNamePdfPdfVersionNodeIdRouteRoute,
  } as any)
const OrganizationNameSettingsIntegrationsAgentConnectionsRoute =
  OrganizationNameSettingsIntegrationsAgentConnectionsRouteImport.update({
    id: '/integrations/agent-connections',
    path: '/integrations/agent-connections',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameSettingsIntegrationsIntegrationTypeRoute =
  OrganizationNameSettingsIntegrationsIntegrationTypeRouteImport.update({
    id: '/integrations/$integrationType',
    path: '/integrations/$integrationType',
    getParentRoute: () => OrganizationNameSettingsRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdBranchesRoute =
  OrganizationNameCbCodebaseIdBranchesRouteImport.update({
    id: '/branches',
    path: '/branches',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameSettingsAccessUsersRouteRoute =
  OrganizationNameSettingsAccessUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => OrganizationNameSettingsAccessRoute,
  } as any)
const OrganizationNameSettingsAccessTeamsRouteRoute =
  OrganizationNameSettingsAccessTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => OrganizationNameSettingsAccessRoute,
  } as any)
const OrganizationNameSettingsAccessSourcesRouteRoute =
  OrganizationNameSettingsAccessSourcesRouteRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => OrganizationNameSettingsAccessRoute,
  } as any)
const OrganizationNamePdfPdfVersionNodeIdSettingsRouteRoute =
  OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => OrganizationNamePdfPdfVersionNodeIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdSettingsRouteRoute =
  OrganizationNameCbCodebaseIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameSettingsMachinesMachineIdIndexRoute =
  OrganizationNameSettingsMachinesMachineIdIndexRouteImport.update({
    id: '/$machineId/',
    path: '/$machineId/',
    getParentRoute: () => OrganizationNameSettingsMachinesRouteRoute,
  } as any)
const OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute =
  OrganizationNameSettingsAnalyticsCodebaseIdIndexRouteImport.update({
    id: '/$codebaseId/',
    path: '/$codebaseId/',
    getParentRoute: () => OrganizationNameSettingsAnalyticsRouteRoute,
  } as any)
const OrganizationNameSettingsAccessUsersIndexRoute =
  OrganizationNameSettingsAccessUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationNameSettingsAccessUsersRouteRoute,
  } as any)
const OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute =
  OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRouteImport.update({
    id: '/autodocs/',
    path: '/autodocs/',
    getParentRoute: () => OrganizationNamePdfPdfVersionNodeIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdAutodocsIndexRoute =
  OrganizationNameCbCodebaseIdAutodocsIndexRouteImport.update({
    id: '/autodocs/',
    path: '/autodocs/',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdAtlasIndexRoute =
  OrganizationNameCbCodebaseIdAtlasIndexRouteImport.update({
    id: '/atlas/',
    path: '/atlas/',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute =
  OrganizationNameDashboardAnalyticsCodebaseIdIndexRouteImport.update({
    id: '/$codebaseId/',
    path: '/$codebaseId/',
    getParentRoute: () => OrganizationNameDashboardAnalyticsRouteRoute,
  } as any)
const OrganizationNameSettingsMachinesMachineIdTabRoute =
  OrganizationNameSettingsMachinesMachineIdTabRouteImport.update({
    id: '/$machineId/$tab',
    path: '/$machineId/$tab',
    getParentRoute: () => OrganizationNameSettingsMachinesRouteRoute,
  } as any)
const OrganizationNameSettingsAnalyticsCodebaseIdTabRoute =
  OrganizationNameSettingsAnalyticsCodebaseIdTabRouteImport.update({
    id: '/$codebaseId/$tab',
    path: '/$codebaseId/$tab',
    getParentRoute: () => OrganizationNameSettingsAnalyticsRouteRoute,
  } as any)
const OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute =
  OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => OrganizationNamePdfPdfVersionNodeIdSettingsRouteRoute,
  } as any)
const OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute =
  OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRouteImport.update({
    id: '/autodocs/$autodocId',
    path: '/autodocs/$autodocId',
    getParentRoute: () => OrganizationNamePdfPdfVersionNodeIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdTreeSplatRoute =
  OrganizationNameCbCodebaseIdTreeSplatRouteImport.update({
    id: '/tree/$',
    path: '/tree/$',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdSettingsGeneralRoute =
  OrganizationNameCbCodebaseIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => OrganizationNameCbCodebaseIdSettingsRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdOverviewSplatRoute =
  OrganizationNameCbCodebaseIdOverviewSplatRouteImport.update({
    id: '/overview/$',
    path: '/overview/$',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdCodeSplatRoute =
  OrganizationNameCbCodebaseIdCodeSplatRouteImport.update({
    id: '/code/$',
    path: '/code/$',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute =
  OrganizationNameCbCodebaseIdAutodocsAutodocIdRouteImport.update({
    id: '/autodocs/$autodocId',
    path: '/autodocs/$autodocId',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameCbCodebaseIdAtlasSplatRoute =
  OrganizationNameCbCodebaseIdAtlasSplatRouteImport.update({
    id: '/atlas/$',
    path: '/atlas/$',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)
const OrganizationNameDashboardAnalyticsCodebaseIdTabRoute =
  OrganizationNameDashboardAnalyticsCodebaseIdTabRouteImport.update({
    id: '/$codebaseId/$tab',
    path: '/$codebaseId/$tab',
    getParentRoute: () => OrganizationNameDashboardAnalyticsRouteRoute,
  } as any)
const OrganizationNameSettingsAccessUsersUserIdIndexRoute =
  OrganizationNameSettingsAccessUsersUserIdIndexRouteImport.update({
    id: '/$userId/',
    path: '/$userId/',
    getParentRoute: () => OrganizationNameSettingsAccessUsersRouteRoute,
  } as any)
const OrganizationNameSettingsAccessTeamsTeamIdIndexRoute =
  OrganizationNameSettingsAccessTeamsTeamIdIndexRouteImport.update({
    id: '/$teamId/',
    path: '/$teamId/',
    getParentRoute: () => OrganizationNameSettingsAccessTeamsRouteRoute,
  } as any)
const OrganizationNameSettingsAccessSourcesSourceIdIndexRoute =
  OrganizationNameSettingsAccessSourcesSourceIdIndexRouteImport.update({
    id: '/$sourceId/',
    path: '/$sourceId/',
    getParentRoute: () => OrganizationNameSettingsAccessSourcesRouteRoute,
  } as any)
const OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute =
  OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRouteImport.update({
    id: '/$organizationName/ws/$workspaceId/cb/$codebaseId/$',
    path: '/$organizationName/ws/$workspaceId/cb/$codebaseId/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationNameSettingsAccessUsersUserIdTabRoute =
  OrganizationNameSettingsAccessUsersUserIdTabRouteImport.update({
    id: '/$userId/$tab',
    path: '/$userId/$tab',
    getParentRoute: () => OrganizationNameSettingsAccessUsersRouteRoute,
  } as any)
const OrganizationNameSettingsAccessTeamsTeamIdTabRoute =
  OrganizationNameSettingsAccessTeamsTeamIdTabRouteImport.update({
    id: '/$teamId/$tab',
    path: '/$teamId/$tab',
    getParentRoute: () => OrganizationNameSettingsAccessTeamsRouteRoute,
  } as any)
const OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute =
  OrganizationNameSettingsAccessSourcesSourceIdBranchesRouteImport.update({
    id: '/$sourceId/branches',
    path: '/$sourceId/branches',
    getParentRoute: () => OrganizationNameSettingsAccessSourcesRouteRoute,
  } as any)
const OrganizationNameSettingsAccessSourcesSourceIdTabRoute =
  OrganizationNameSettingsAccessSourcesSourceIdTabRouteImport.update({
    id: '/$sourceId/$tab',
    path: '/$sourceId/$tab',
    getParentRoute: () => OrganizationNameSettingsAccessSourcesRouteRoute,
  } as any)
const OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute =
  OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRouteImport.update(
    {
      id: '/autodocs/page/$pageVersionNodeId',
      path: '/autodocs/page/$pageVersionNodeId',
      getParentRoute: () => OrganizationNamePdfPdfVersionNodeIdRouteRoute,
    } as any,
  )
const OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute =
  OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRouteImport.update({
    id: '/autodocs/page/$pageVersionNodeId',
    path: '/autodocs/page/$pageVersionNodeId',
    getParentRoute: () => OrganizationNameCbCodebaseIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/logout': typeof LogoutRoute
  '/$organizationName': typeof OrganizationNameDashboardRouteRouteWithChildren
  '/$organizationName/investigations': typeof OrganizationNameInvestigationsRouteRouteWithChildren
  '/$organizationName/org-docs': typeof OrganizationNameOrgDocsRouteRouteWithChildren
  '/$organizationName/settings': typeof OrganizationNameSettingsRouteRouteWithChildren
  '/$organizationName/about-you': typeof OrganizationNameAboutYouRoute
  '/$organizationName/library': typeof OrganizationNameLibraryRoute
  '/$organizationName/mcp': typeof OrganizationNameMcpRoute
  '/$organizationName/usage': typeof OrganizationNameUsageRoute
  '/signup': typeof PublicSignupRoute
  '/investigations/$investigationId': typeof InvestigationsInvestigationIdRoute
  '/$organizationName/': typeof OrganizationNameIndexRoute
  '/$organizationName/analytics': typeof OrganizationNameDashboardAnalyticsRouteRouteWithChildren
  '/$organizationName/cb/$codebaseId': typeof OrganizationNameCbCodebaseIdRouteRouteWithChildren
  '/$organizationName/pdf/$pdfVersionNodeId': typeof OrganizationNamePdfPdfVersionNodeIdRouteRouteWithChildren
  '/$organizationName/settings/access-tokens': typeof OrganizationNameSettingsAccessTokensRouteRoute
  '/$organizationName/settings/analytics': typeof OrganizationNameSettingsAnalyticsRouteRouteWithChildren
  '/$organizationName/settings/machines': typeof OrganizationNameSettingsMachinesRouteRouteWithChildren
  '/$organizationName/branches': typeof OrganizationNameDashboardBranchesRoute
  '/$organizationName/sources': typeof OrganizationNameDashboardSourcesRoute
  '/$organizationName/investigations/$investigationId': typeof OrganizationNameInvestigationsInvestigationIdRoute
  '/$organizationName/investigations/new': typeof OrganizationNameInvestigationsNewRoute
  '/$organizationName/org-docs/$pageVersionNodeId': typeof OrganizationNameOrgDocsPageVersionNodeIdRoute
  '/$organizationName/settings/account': typeof OrganizationNameSettingsAccountRoute
  '/$organizationName/settings/agentcore': typeof OrganizationNameSettingsAgentcoreRoute
  '/$organizationName/settings/billing': typeof OrganizationNameSettingsBillingRoute
  '/$organizationName/settings/byom': typeof OrganizationNameSettingsByomRoute
  '/$organizationName/settings/labs': typeof OrganizationNameSettingsLabsRoute
  '/$organizationName/settings/organization': typeof OrganizationNameSettingsOrganizationRoute
  '/$organizationName/settings/sso-scim': typeof OrganizationNameSettingsSsoScimRoute
  '/$organizationName/settings/usage': typeof OrganizationNameSettingsUsageRoute
  '/$organizationName/settings/workspace': typeof OrganizationNameSettingsWorkspaceRoute
  '/$organizationName/investigations/': typeof OrganizationNameInvestigationsIndexRoute
  '/$organizationName/org-docs/': typeof OrganizationNameOrgDocsIndexRoute
  '/$organizationName/settings/': typeof OrganizationNameSettingsIndexRoute
  '/$organizationName/cb/$codebaseId/settings': typeof OrganizationNameCbCodebaseIdSettingsRouteRouteWithChildren
  '/$organizationName/pdf/$pdfVersionNodeId/settings': typeof OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteWithChildren
  '/$organizationName/settings/sources': typeof OrganizationNameSettingsAccessSourcesRouteRouteWithChildren
  '/$organizationName/settings/teams': typeof OrganizationNameSettingsAccessTeamsRouteRouteWithChildren
  '/$organizationName/settings/users': typeof OrganizationNameSettingsAccessUsersRouteRouteWithChildren
  '/$organizationName/cb/$codebaseId/branches': typeof OrganizationNameCbCodebaseIdBranchesRoute
  '/$organizationName/settings/integrations/$integrationType': typeof OrganizationNameSettingsIntegrationsIntegrationTypeRoute
  '/$organizationName/settings/integrations/agent-connections': typeof OrganizationNameSettingsIntegrationsAgentConnectionsRoute
  '/$organizationName/pdf/$pdfVersionNodeId/': typeof OrganizationNamePdfPdfVersionNodeIdIndexRoute
  '/$organizationName/settings/integrations/': typeof OrganizationNameSettingsIntegrationsIndexRoute
  '/$organizationName/settings/machines/': typeof OrganizationNameSettingsMachinesIndexRoute
  '/$organizationName/analytics/$codebaseId/$tab': typeof OrganizationNameDashboardAnalyticsCodebaseIdTabRoute
  '/$organizationName/cb/$codebaseId/atlas/$': typeof OrganizationNameCbCodebaseIdAtlasSplatRoute
  '/$organizationName/cb/$codebaseId/autodocs/$autodocId': typeof OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute
  '/$organizationName/cb/$codebaseId/code/$': typeof OrganizationNameCbCodebaseIdCodeSplatRoute
  '/$organizationName/cb/$codebaseId/overview/$': typeof OrganizationNameCbCodebaseIdOverviewSplatRoute
  '/$organizationName/cb/$codebaseId/settings/general': typeof OrganizationNameCbCodebaseIdSettingsGeneralRoute
  '/$organizationName/cb/$codebaseId/tree/$': typeof OrganizationNameCbCodebaseIdTreeSplatRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute
  '/$organizationName/pdf/$pdfVersionNodeId/settings/general': typeof OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute
  '/$organizationName/settings/analytics/$codebaseId/$tab': typeof OrganizationNameSettingsAnalyticsCodebaseIdTabRoute
  '/$organizationName/settings/machines/$machineId/$tab': typeof OrganizationNameSettingsMachinesMachineIdTabRoute
  '/$organizationName/analytics/$codebaseId/': typeof OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute
  '/$organizationName/cb/$codebaseId/atlas/': typeof OrganizationNameCbCodebaseIdAtlasIndexRoute
  '/$organizationName/cb/$codebaseId/autodocs/': typeof OrganizationNameCbCodebaseIdAutodocsIndexRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute
  '/$organizationName/settings/users/': typeof OrganizationNameSettingsAccessUsersIndexRoute
  '/$organizationName/settings/analytics/$codebaseId/': typeof OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute
  '/$organizationName/settings/machines/$machineId/': typeof OrganizationNameSettingsMachinesMachineIdIndexRoute
  '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId': typeof OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute
  '/$organizationName/settings/sources/$sourceId/$tab': typeof OrganizationNameSettingsAccessSourcesSourceIdTabRoute
  '/$organizationName/settings/sources/$sourceId/branches': typeof OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute
  '/$organizationName/settings/teams/$teamId/$tab': typeof OrganizationNameSettingsAccessTeamsTeamIdTabRoute
  '/$organizationName/settings/users/$userId/$tab': typeof OrganizationNameSettingsAccessUsersUserIdTabRoute
  '/$organizationName/ws/$workspaceId/cb/$codebaseId/$': typeof OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute
  '/$organizationName/settings/sources/$sourceId/': typeof OrganizationNameSettingsAccessSourcesSourceIdIndexRoute
  '/$organizationName/settings/teams/$teamId/': typeof OrganizationNameSettingsAccessTeamsTeamIdIndexRoute
  '/$organizationName/settings/users/$userId/': typeof OrganizationNameSettingsAccessUsersUserIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/logout': typeof LogoutRoute
  '/$organizationName': typeof OrganizationNameIndexRoute
  '/$organizationName/about-you': typeof OrganizationNameAboutYouRoute
  '/$organizationName/library': typeof OrganizationNameLibraryRoute
  '/$organizationName/mcp': typeof OrganizationNameMcpRoute
  '/$organizationName/usage': typeof OrganizationNameUsageRoute
  '/signup': typeof PublicSignupRoute
  '/investigations/$investigationId': typeof InvestigationsInvestigationIdRoute
  '/$organizationName/analytics': typeof OrganizationNameDashboardAnalyticsRouteRouteWithChildren
  '/$organizationName/cb/$codebaseId': typeof OrganizationNameCbCodebaseIdRouteRouteWithChildren
  '/$organizationName/settings/access-tokens': typeof OrganizationNameSettingsAccessTokensRouteRoute
  '/$organizationName/settings/analytics': typeof OrganizationNameSettingsAnalyticsRouteRouteWithChildren
  '/$organizationName/branches': typeof OrganizationNameDashboardBranchesRoute
  '/$organizationName/sources': typeof OrganizationNameDashboardSourcesRoute
  '/$organizationName/investigations/$investigationId': typeof OrganizationNameInvestigationsInvestigationIdRoute
  '/$organizationName/investigations/new': typeof OrganizationNameInvestigationsNewRoute
  '/$organizationName/org-docs/$pageVersionNodeId': typeof OrganizationNameOrgDocsPageVersionNodeIdRoute
  '/$organizationName/settings': typeof OrganizationNameSettingsIndexRoute
  '/$organizationName/settings/account': typeof OrganizationNameSettingsAccountRoute
  '/$organizationName/settings/agentcore': typeof OrganizationNameSettingsAgentcoreRoute
  '/$organizationName/settings/billing': typeof OrganizationNameSettingsBillingRoute
  '/$organizationName/settings/byom': typeof OrganizationNameSettingsByomRoute
  '/$organizationName/settings/labs': typeof OrganizationNameSettingsLabsRoute
  '/$organizationName/settings/organization': typeof OrganizationNameSettingsOrganizationRoute
  '/$organizationName/settings/sso-scim': typeof OrganizationNameSettingsSsoScimRoute
  '/$organizationName/settings/usage': typeof OrganizationNameSettingsUsageRoute
  '/$organizationName/settings/workspace': typeof OrganizationNameSettingsWorkspaceRoute
  '/$organizationName/investigations': typeof OrganizationNameInvestigationsIndexRoute
  '/$organizationName/org-docs': typeof OrganizationNameOrgDocsIndexRoute
  '/$organizationName/cb/$codebaseId/settings': typeof OrganizationNameCbCodebaseIdSettingsRouteRouteWithChildren
  '/$organizationName/pdf/$pdfVersionNodeId/settings': typeof OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteWithChildren
  '/$organizationName/settings/sources': typeof OrganizationNameSettingsAccessSourcesRouteRouteWithChildren
  '/$organizationName/settings/teams': typeof OrganizationNameSettingsAccessTeamsRouteRouteWithChildren
  '/$organizationName/cb/$codebaseId/branches': typeof OrganizationNameCbCodebaseIdBranchesRoute
  '/$organizationName/settings/integrations/$integrationType': typeof OrganizationNameSettingsIntegrationsIntegrationTypeRoute
  '/$organizationName/settings/integrations/agent-connections': typeof OrganizationNameSettingsIntegrationsAgentConnectionsRoute
  '/$organizationName/pdf/$pdfVersionNodeId': typeof OrganizationNamePdfPdfVersionNodeIdIndexRoute
  '/$organizationName/settings/integrations': typeof OrganizationNameSettingsIntegrationsIndexRoute
  '/$organizationName/settings/machines': typeof OrganizationNameSettingsMachinesIndexRoute
  '/$organizationName/analytics/$codebaseId/$tab': typeof OrganizationNameDashboardAnalyticsCodebaseIdTabRoute
  '/$organizationName/cb/$codebaseId/atlas/$': typeof OrganizationNameCbCodebaseIdAtlasSplatRoute
  '/$organizationName/cb/$codebaseId/autodocs/$autodocId': typeof OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute
  '/$organizationName/cb/$codebaseId/code/$': typeof OrganizationNameCbCodebaseIdCodeSplatRoute
  '/$organizationName/cb/$codebaseId/overview/$': typeof OrganizationNameCbCodebaseIdOverviewSplatRoute
  '/$organizationName/cb/$codebaseId/settings/general': typeof OrganizationNameCbCodebaseIdSettingsGeneralRoute
  '/$organizationName/cb/$codebaseId/tree/$': typeof OrganizationNameCbCodebaseIdTreeSplatRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute
  '/$organizationName/pdf/$pdfVersionNodeId/settings/general': typeof OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute
  '/$organizationName/settings/analytics/$codebaseId/$tab': typeof OrganizationNameSettingsAnalyticsCodebaseIdTabRoute
  '/$organizationName/settings/machines/$machineId/$tab': typeof OrganizationNameSettingsMachinesMachineIdTabRoute
  '/$organizationName/analytics/$codebaseId': typeof OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute
  '/$organizationName/cb/$codebaseId/atlas': typeof OrganizationNameCbCodebaseIdAtlasIndexRoute
  '/$organizationName/cb/$codebaseId/autodocs': typeof OrganizationNameCbCodebaseIdAutodocsIndexRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute
  '/$organizationName/settings/users': typeof OrganizationNameSettingsAccessUsersIndexRoute
  '/$organizationName/settings/analytics/$codebaseId': typeof OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute
  '/$organizationName/settings/machines/$machineId': typeof OrganizationNameSettingsMachinesMachineIdIndexRoute
  '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId': typeof OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute
  '/$organizationName/settings/sources/$sourceId/$tab': typeof OrganizationNameSettingsAccessSourcesSourceIdTabRoute
  '/$organizationName/settings/sources/$sourceId/branches': typeof OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute
  '/$organizationName/settings/teams/$teamId/$tab': typeof OrganizationNameSettingsAccessTeamsTeamIdTabRoute
  '/$organizationName/settings/users/$userId/$tab': typeof OrganizationNameSettingsAccessUsersUserIdTabRoute
  '/$organizationName/ws/$workspaceId/cb/$codebaseId/$': typeof OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute
  '/$organizationName/settings/sources/$sourceId': typeof OrganizationNameSettingsAccessSourcesSourceIdIndexRoute
  '/$organizationName/settings/teams/$teamId': typeof OrganizationNameSettingsAccessTeamsTeamIdIndexRoute
  '/$organizationName/settings/users/$userId': typeof OrganizationNameSettingsAccessUsersUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/_public': typeof PublicRouteWithChildren
  '/logout': typeof LogoutRoute
  '/$organizationName/_dashboard': typeof OrganizationNameDashboardRouteRouteWithChildren
  '/$organizationName/investigations': typeof OrganizationNameInvestigationsRouteRouteWithChildren
  '/$organizationName/org-docs': typeof OrganizationNameOrgDocsRouteRouteWithChildren
  '/$organizationName/settings': typeof OrganizationNameSettingsRouteRouteWithChildren
  '/$organizationName/about-you': typeof OrganizationNameAboutYouRoute
  '/$organizationName/library': typeof OrganizationNameLibraryRoute
  '/$organizationName/mcp': typeof OrganizationNameMcpRoute
  '/$organizationName/usage': typeof OrganizationNameUsageRoute
  '/_public/signup': typeof PublicSignupRoute
  '/investigations/$investigationId': typeof InvestigationsInvestigationIdRoute
  '/$organizationName/': typeof OrganizationNameIndexRoute
  '/$organizationName/_dashboard/analytics': typeof OrganizationNameDashboardAnalyticsRouteRouteWithChildren
  '/$organizationName/cb/$codebaseId': typeof OrganizationNameCbCodebaseIdRouteRouteWithChildren
  '/$organizationName/pdf/$pdfVersionNodeId': typeof OrganizationNamePdfPdfVersionNodeIdRouteRouteWithChildren
  '/$organizationName/settings/access-tokens': typeof OrganizationNameSettingsAccessTokensRouteRoute
  '/$organizationName/settings/analytics': typeof OrganizationNameSettingsAnalyticsRouteRouteWithChildren
  '/$organizationName/settings/machines': typeof OrganizationNameSettingsMachinesRouteRouteWithChildren
  '/$organizationName/_dashboard/branches': typeof OrganizationNameDashboardBranchesRoute
  '/$organizationName/_dashboard/sources': typeof OrganizationNameDashboardSourcesRoute
  '/$organizationName/investigations/$investigationId': typeof OrganizationNameInvestigationsInvestigationIdRoute
  '/$organizationName/investigations/new': typeof OrganizationNameInvestigationsNewRoute
  '/$organizationName/org-docs/$pageVersionNodeId': typeof OrganizationNameOrgDocsPageVersionNodeIdRoute
  '/$organizationName/settings/_access': typeof OrganizationNameSettingsAccessRouteWithChildren
  '/$organizationName/settings/account': typeof OrganizationNameSettingsAccountRoute
  '/$organizationName/settings/agentcore': typeof OrganizationNameSettingsAgentcoreRoute
  '/$organizationName/settings/billing': typeof OrganizationNameSettingsBillingRoute
  '/$organizationName/settings/byom': typeof OrganizationNameSettingsByomRoute
  '/$organizationName/settings/labs': typeof OrganizationNameSettingsLabsRoute
  '/$organizationName/settings/organization': typeof OrganizationNameSettingsOrganizationRoute
  '/$organizationName/settings/sso-scim': typeof OrganizationNameSettingsSsoScimRoute
  '/$organizationName/settings/usage': typeof OrganizationNameSettingsUsageRoute
  '/$organizationName/settings/workspace': typeof OrganizationNameSettingsWorkspaceRoute
  '/$organizationName/investigations/': typeof OrganizationNameInvestigationsIndexRoute
  '/$organizationName/org-docs/': typeof OrganizationNameOrgDocsIndexRoute
  '/$organizationName/settings/': typeof OrganizationNameSettingsIndexRoute
  '/$organizationName/cb/$codebaseId/settings': typeof OrganizationNameCbCodebaseIdSettingsRouteRouteWithChildren
  '/$organizationName/pdf/$pdfVersionNodeId/settings': typeof OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteWithChildren
  '/$organizationName/settings/_access/sources': typeof OrganizationNameSettingsAccessSourcesRouteRouteWithChildren
  '/$organizationName/settings/_access/teams': typeof OrganizationNameSettingsAccessTeamsRouteRouteWithChildren
  '/$organizationName/settings/_access/users': typeof OrganizationNameSettingsAccessUsersRouteRouteWithChildren
  '/$organizationName/cb/$codebaseId/branches': typeof OrganizationNameCbCodebaseIdBranchesRoute
  '/$organizationName/settings/integrations/$integrationType': typeof OrganizationNameSettingsIntegrationsIntegrationTypeRoute
  '/$organizationName/settings/integrations/agent-connections': typeof OrganizationNameSettingsIntegrationsAgentConnectionsRoute
  '/$organizationName/pdf/$pdfVersionNodeId/': typeof OrganizationNamePdfPdfVersionNodeIdIndexRoute
  '/$organizationName/settings/integrations/': typeof OrganizationNameSettingsIntegrationsIndexRoute
  '/$organizationName/settings/machines/': typeof OrganizationNameSettingsMachinesIndexRoute
  '/$organizationName/_dashboard/analytics/$codebaseId/$tab': typeof OrganizationNameDashboardAnalyticsCodebaseIdTabRoute
  '/$organizationName/cb/$codebaseId/atlas/$': typeof OrganizationNameCbCodebaseIdAtlasSplatRoute
  '/$organizationName/cb/$codebaseId/autodocs/$autodocId': typeof OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute
  '/$organizationName/cb/$codebaseId/code/$': typeof OrganizationNameCbCodebaseIdCodeSplatRoute
  '/$organizationName/cb/$codebaseId/overview/$': typeof OrganizationNameCbCodebaseIdOverviewSplatRoute
  '/$organizationName/cb/$codebaseId/settings/general': typeof OrganizationNameCbCodebaseIdSettingsGeneralRoute
  '/$organizationName/cb/$codebaseId/tree/$': typeof OrganizationNameCbCodebaseIdTreeSplatRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute
  '/$organizationName/pdf/$pdfVersionNodeId/settings/general': typeof OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute
  '/$organizationName/settings/analytics/$codebaseId/$tab': typeof OrganizationNameSettingsAnalyticsCodebaseIdTabRoute
  '/$organizationName/settings/machines/$machineId/$tab': typeof OrganizationNameSettingsMachinesMachineIdTabRoute
  '/$organizationName/_dashboard/analytics/$codebaseId/': typeof OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute
  '/$organizationName/cb/$codebaseId/atlas/': typeof OrganizationNameCbCodebaseIdAtlasIndexRoute
  '/$organizationName/cb/$codebaseId/autodocs/': typeof OrganizationNameCbCodebaseIdAutodocsIndexRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute
  '/$organizationName/settings/_access/users/': typeof OrganizationNameSettingsAccessUsersIndexRoute
  '/$organizationName/settings/analytics/$codebaseId/': typeof OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute
  '/$organizationName/settings/machines/$machineId/': typeof OrganizationNameSettingsMachinesMachineIdIndexRoute
  '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId': typeof OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute
  '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId': typeof OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute
  '/$organizationName/settings/_access/sources/$sourceId/$tab': typeof OrganizationNameSettingsAccessSourcesSourceIdTabRoute
  '/$organizationName/settings/_access/sources/$sourceId/branches': typeof OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute
  '/$organizationName/settings/_access/teams/$teamId/$tab': typeof OrganizationNameSettingsAccessTeamsTeamIdTabRoute
  '/$organizationName/settings/_access/users/$userId/$tab': typeof OrganizationNameSettingsAccessUsersUserIdTabRoute
  '/$organizationName/ws/$workspaceId/cb/$codebaseId/$': typeof OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute
  '/$organizationName/settings/_access/sources/$sourceId/': typeof OrganizationNameSettingsAccessSourcesSourceIdIndexRoute
  '/$organizationName/settings/_access/teams/$teamId/': typeof OrganizationNameSettingsAccessTeamsTeamIdIndexRoute
  '/$organizationName/settings/_access/users/$userId/': typeof OrganizationNameSettingsAccessUsersUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/logout'
    | '/$organizationName'
    | '/$organizationName/investigations'
    | '/$organizationName/org-docs'
    | '/$organizationName/settings'
    | '/$organizationName/about-you'
    | '/$organizationName/library'
    | '/$organizationName/mcp'
    | '/$organizationName/usage'
    | '/signup'
    | '/investigations/$investigationId'
    | '/$organizationName/'
    | '/$organizationName/analytics'
    | '/$organizationName/cb/$codebaseId'
    | '/$organizationName/pdf/$pdfVersionNodeId'
    | '/$organizationName/settings/access-tokens'
    | '/$organizationName/settings/analytics'
    | '/$organizationName/settings/machines'
    | '/$organizationName/branches'
    | '/$organizationName/sources'
    | '/$organizationName/investigations/$investigationId'
    | '/$organizationName/investigations/new'
    | '/$organizationName/org-docs/$pageVersionNodeId'
    | '/$organizationName/settings/account'
    | '/$organizationName/settings/agentcore'
    | '/$organizationName/settings/billing'
    | '/$organizationName/settings/byom'
    | '/$organizationName/settings/labs'
    | '/$organizationName/settings/organization'
    | '/$organizationName/settings/sso-scim'
    | '/$organizationName/settings/usage'
    | '/$organizationName/settings/workspace'
    | '/$organizationName/investigations/'
    | '/$organizationName/org-docs/'
    | '/$organizationName/settings/'
    | '/$organizationName/cb/$codebaseId/settings'
    | '/$organizationName/pdf/$pdfVersionNodeId/settings'
    | '/$organizationName/settings/sources'
    | '/$organizationName/settings/teams'
    | '/$organizationName/settings/users'
    | '/$organizationName/cb/$codebaseId/branches'
    | '/$organizationName/settings/integrations/$integrationType'
    | '/$organizationName/settings/integrations/agent-connections'
    | '/$organizationName/pdf/$pdfVersionNodeId/'
    | '/$organizationName/settings/integrations/'
    | '/$organizationName/settings/machines/'
    | '/$organizationName/analytics/$codebaseId/$tab'
    | '/$organizationName/cb/$codebaseId/atlas/$'
    | '/$organizationName/cb/$codebaseId/autodocs/$autodocId'
    | '/$organizationName/cb/$codebaseId/code/$'
    | '/$organizationName/cb/$codebaseId/overview/$'
    | '/$organizationName/cb/$codebaseId/settings/general'
    | '/$organizationName/cb/$codebaseId/tree/$'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId'
    | '/$organizationName/pdf/$pdfVersionNodeId/settings/general'
    | '/$organizationName/settings/analytics/$codebaseId/$tab'
    | '/$organizationName/settings/machines/$machineId/$tab'
    | '/$organizationName/analytics/$codebaseId/'
    | '/$organizationName/cb/$codebaseId/atlas/'
    | '/$organizationName/cb/$codebaseId/autodocs/'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/'
    | '/$organizationName/settings/users/'
    | '/$organizationName/settings/analytics/$codebaseId/'
    | '/$organizationName/settings/machines/$machineId/'
    | '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId'
    | '/$organizationName/settings/sources/$sourceId/$tab'
    | '/$organizationName/settings/sources/$sourceId/branches'
    | '/$organizationName/settings/teams/$teamId/$tab'
    | '/$organizationName/settings/users/$userId/$tab'
    | '/$organizationName/ws/$workspaceId/cb/$codebaseId/$'
    | '/$organizationName/settings/sources/$sourceId/'
    | '/$organizationName/settings/teams/$teamId/'
    | '/$organizationName/settings/users/$userId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/logout'
    | '/$organizationName'
    | '/$organizationName/about-you'
    | '/$organizationName/library'
    | '/$organizationName/mcp'
    | '/$organizationName/usage'
    | '/signup'
    | '/investigations/$investigationId'
    | '/$organizationName/analytics'
    | '/$organizationName/cb/$codebaseId'
    | '/$organizationName/settings/access-tokens'
    | '/$organizationName/settings/analytics'
    | '/$organizationName/branches'
    | '/$organizationName/sources'
    | '/$organizationName/investigations/$investigationId'
    | '/$organizationName/investigations/new'
    | '/$organizationName/org-docs/$pageVersionNodeId'
    | '/$organizationName/settings'
    | '/$organizationName/settings/account'
    | '/$organizationName/settings/agentcore'
    | '/$organizationName/settings/billing'
    | '/$organizationName/settings/byom'
    | '/$organizationName/settings/labs'
    | '/$organizationName/settings/organization'
    | '/$organizationName/settings/sso-scim'
    | '/$organizationName/settings/usage'
    | '/$organizationName/settings/workspace'
    | '/$organizationName/investigations'
    | '/$organizationName/org-docs'
    | '/$organizationName/cb/$codebaseId/settings'
    | '/$organizationName/pdf/$pdfVersionNodeId/settings'
    | '/$organizationName/settings/sources'
    | '/$organizationName/settings/teams'
    | '/$organizationName/cb/$codebaseId/branches'
    | '/$organizationName/settings/integrations/$integrationType'
    | '/$organizationName/settings/integrations/agent-connections'
    | '/$organizationName/pdf/$pdfVersionNodeId'
    | '/$organizationName/settings/integrations'
    | '/$organizationName/settings/machines'
    | '/$organizationName/analytics/$codebaseId/$tab'
    | '/$organizationName/cb/$codebaseId/atlas/$'
    | '/$organizationName/cb/$codebaseId/autodocs/$autodocId'
    | '/$organizationName/cb/$codebaseId/code/$'
    | '/$organizationName/cb/$codebaseId/overview/$'
    | '/$organizationName/cb/$codebaseId/settings/general'
    | '/$organizationName/cb/$codebaseId/tree/$'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId'
    | '/$organizationName/pdf/$pdfVersionNodeId/settings/general'
    | '/$organizationName/settings/analytics/$codebaseId/$tab'
    | '/$organizationName/settings/machines/$machineId/$tab'
    | '/$organizationName/analytics/$codebaseId'
    | '/$organizationName/cb/$codebaseId/atlas'
    | '/$organizationName/cb/$codebaseId/autodocs'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs'
    | '/$organizationName/settings/users'
    | '/$organizationName/settings/analytics/$codebaseId'
    | '/$organizationName/settings/machines/$machineId'
    | '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId'
    | '/$organizationName/settings/sources/$sourceId/$tab'
    | '/$organizationName/settings/sources/$sourceId/branches'
    | '/$organizationName/settings/teams/$teamId/$tab'
    | '/$organizationName/settings/users/$userId/$tab'
    | '/$organizationName/ws/$workspaceId/cb/$codebaseId/$'
    | '/$organizationName/settings/sources/$sourceId'
    | '/$organizationName/settings/teams/$teamId'
    | '/$organizationName/settings/users/$userId'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/_public'
    | '/logout'
    | '/$organizationName/_dashboard'
    | '/$organizationName/investigations'
    | '/$organizationName/org-docs'
    | '/$organizationName/settings'
    | '/$organizationName/about-you'
    | '/$organizationName/library'
    | '/$organizationName/mcp'
    | '/$organizationName/usage'
    | '/_public/signup'
    | '/investigations/$investigationId'
    | '/$organizationName/'
    | '/$organizationName/_dashboard/analytics'
    | '/$organizationName/cb/$codebaseId'
    | '/$organizationName/pdf/$pdfVersionNodeId'
    | '/$organizationName/settings/access-tokens'
    | '/$organizationName/settings/analytics'
    | '/$organizationName/settings/machines'
    | '/$organizationName/_dashboard/branches'
    | '/$organizationName/_dashboard/sources'
    | '/$organizationName/investigations/$investigationId'
    | '/$organizationName/investigations/new'
    | '/$organizationName/org-docs/$pageVersionNodeId'
    | '/$organizationName/settings/_access'
    | '/$organizationName/settings/account'
    | '/$organizationName/settings/agentcore'
    | '/$organizationName/settings/billing'
    | '/$organizationName/settings/byom'
    | '/$organizationName/settings/labs'
    | '/$organizationName/settings/organization'
    | '/$organizationName/settings/sso-scim'
    | '/$organizationName/settings/usage'
    | '/$organizationName/settings/workspace'
    | '/$organizationName/investigations/'
    | '/$organizationName/org-docs/'
    | '/$organizationName/settings/'
    | '/$organizationName/cb/$codebaseId/settings'
    | '/$organizationName/pdf/$pdfVersionNodeId/settings'
    | '/$organizationName/settings/_access/sources'
    | '/$organizationName/settings/_access/teams'
    | '/$organizationName/settings/_access/users'
    | '/$organizationName/cb/$codebaseId/branches'
    | '/$organizationName/settings/integrations/$integrationType'
    | '/$organizationName/settings/integrations/agent-connections'
    | '/$organizationName/pdf/$pdfVersionNodeId/'
    | '/$organizationName/settings/integrations/'
    | '/$organizationName/settings/machines/'
    | '/$organizationName/_dashboard/analytics/$codebaseId/$tab'
    | '/$organizationName/cb/$codebaseId/atlas/$'
    | '/$organizationName/cb/$codebaseId/autodocs/$autodocId'
    | '/$organizationName/cb/$codebaseId/code/$'
    | '/$organizationName/cb/$codebaseId/overview/$'
    | '/$organizationName/cb/$codebaseId/settings/general'
    | '/$organizationName/cb/$codebaseId/tree/$'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId'
    | '/$organizationName/pdf/$pdfVersionNodeId/settings/general'
    | '/$organizationName/settings/analytics/$codebaseId/$tab'
    | '/$organizationName/settings/machines/$machineId/$tab'
    | '/$organizationName/_dashboard/analytics/$codebaseId/'
    | '/$organizationName/cb/$codebaseId/atlas/'
    | '/$organizationName/cb/$codebaseId/autodocs/'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/'
    | '/$organizationName/settings/_access/users/'
    | '/$organizationName/settings/analytics/$codebaseId/'
    | '/$organizationName/settings/machines/$machineId/'
    | '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId'
    | '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId'
    | '/$organizationName/settings/_access/sources/$sourceId/$tab'
    | '/$organizationName/settings/_access/sources/$sourceId/branches'
    | '/$organizationName/settings/_access/teams/$teamId/$tab'
    | '/$organizationName/settings/_access/users/$userId/$tab'
    | '/$organizationName/ws/$workspaceId/cb/$codebaseId/$'
    | '/$organizationName/settings/_access/sources/$sourceId/'
    | '/$organizationName/settings/_access/teams/$teamId/'
    | '/$organizationName/settings/_access/users/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  PublicRoute: typeof PublicRouteWithChildren
  LogoutRoute: typeof LogoutRoute
  OrganizationNameDashboardRouteRoute: typeof OrganizationNameDashboardRouteRouteWithChildren
  OrganizationNameInvestigationsRouteRoute: typeof OrganizationNameInvestigationsRouteRouteWithChildren
  OrganizationNameOrgDocsRouteRoute: typeof OrganizationNameOrgDocsRouteRouteWithChildren
  OrganizationNameSettingsRouteRoute: typeof OrganizationNameSettingsRouteRouteWithChildren
  OrganizationNameAboutYouRoute: typeof OrganizationNameAboutYouRoute
  OrganizationNameLibraryRoute: typeof OrganizationNameLibraryRoute
  OrganizationNameMcpRoute: typeof OrganizationNameMcpRoute
  OrganizationNameUsageRoute: typeof OrganizationNameUsageRoute
  InvestigationsInvestigationIdRoute: typeof InvestigationsInvestigationIdRoute
  OrganizationNameIndexRoute: typeof OrganizationNameIndexRoute
  OrganizationNameCbCodebaseIdRouteRoute: typeof OrganizationNameCbCodebaseIdRouteRouteWithChildren
  OrganizationNamePdfPdfVersionNodeIdRouteRoute: typeof OrganizationNamePdfPdfVersionNodeIdRouteRouteWithChildren
  OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute: typeof OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/': {
      id: '/$organizationName/'
      path: '/$organizationName'
      fullPath: '/$organizationName/'
      preLoaderRoute: typeof OrganizationNameIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/investigations/$investigationId': {
      id: '/investigations/$investigationId'
      path: '/investigations/$investigationId'
      fullPath: '/investigations/$investigationId'
      preLoaderRoute: typeof InvestigationsInvestigationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/$organizationName/usage': {
      id: '/$organizationName/usage'
      path: '/$organizationName/usage'
      fullPath: '/$organizationName/usage'
      preLoaderRoute: typeof OrganizationNameUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/mcp': {
      id: '/$organizationName/mcp'
      path: '/$organizationName/mcp'
      fullPath: '/$organizationName/mcp'
      preLoaderRoute: typeof OrganizationNameMcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/library': {
      id: '/$organizationName/library'
      path: '/$organizationName/library'
      fullPath: '/$organizationName/library'
      preLoaderRoute: typeof OrganizationNameLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/about-you': {
      id: '/$organizationName/about-you'
      path: '/$organizationName/about-you'
      fullPath: '/$organizationName/about-you'
      preLoaderRoute: typeof OrganizationNameAboutYouRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/settings': {
      id: '/$organizationName/settings'
      path: '/$organizationName/settings'
      fullPath: '/$organizationName/settings'
      preLoaderRoute: typeof OrganizationNameSettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/org-docs': {
      id: '/$organizationName/org-docs'
      path: '/$organizationName/org-docs'
      fullPath: '/$organizationName/org-docs'
      preLoaderRoute: typeof OrganizationNameOrgDocsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/investigations': {
      id: '/$organizationName/investigations'
      path: '/$organizationName/investigations'
      fullPath: '/$organizationName/investigations'
      preLoaderRoute: typeof OrganizationNameInvestigationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/_dashboard': {
      id: '/$organizationName/_dashboard'
      path: '/$organizationName'
      fullPath: '/$organizationName'
      preLoaderRoute: typeof OrganizationNameDashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/settings/': {
      id: '/$organizationName/settings/'
      path: '/'
      fullPath: '/$organizationName/settings/'
      preLoaderRoute: typeof OrganizationNameSettingsIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/org-docs/': {
      id: '/$organizationName/org-docs/'
      path: '/'
      fullPath: '/$organizationName/org-docs/'
      preLoaderRoute: typeof OrganizationNameOrgDocsIndexRouteImport
      parentRoute: typeof OrganizationNameOrgDocsRouteRoute
    }
    '/$organizationName/investigations/': {
      id: '/$organizationName/investigations/'
      path: '/'
      fullPath: '/$organizationName/investigations/'
      preLoaderRoute: typeof OrganizationNameInvestigationsIndexRouteImport
      parentRoute: typeof OrganizationNameInvestigationsRouteRoute
    }
    '/$organizationName/settings/workspace': {
      id: '/$organizationName/settings/workspace'
      path: '/workspace'
      fullPath: '/$organizationName/settings/workspace'
      preLoaderRoute: typeof OrganizationNameSettingsWorkspaceRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/usage': {
      id: '/$organizationName/settings/usage'
      path: '/usage'
      fullPath: '/$organizationName/settings/usage'
      preLoaderRoute: typeof OrganizationNameSettingsUsageRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/sso-scim': {
      id: '/$organizationName/settings/sso-scim'
      path: '/sso-scim'
      fullPath: '/$organizationName/settings/sso-scim'
      preLoaderRoute: typeof OrganizationNameSettingsSsoScimRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/organization': {
      id: '/$organizationName/settings/organization'
      path: '/organization'
      fullPath: '/$organizationName/settings/organization'
      preLoaderRoute: typeof OrganizationNameSettingsOrganizationRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/labs': {
      id: '/$organizationName/settings/labs'
      path: '/labs'
      fullPath: '/$organizationName/settings/labs'
      preLoaderRoute: typeof OrganizationNameSettingsLabsRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/byom': {
      id: '/$organizationName/settings/byom'
      path: '/byom'
      fullPath: '/$organizationName/settings/byom'
      preLoaderRoute: typeof OrganizationNameSettingsByomRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/billing': {
      id: '/$organizationName/settings/billing'
      path: '/billing'
      fullPath: '/$organizationName/settings/billing'
      preLoaderRoute: typeof OrganizationNameSettingsBillingRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/agentcore': {
      id: '/$organizationName/settings/agentcore'
      path: '/agentcore'
      fullPath: '/$organizationName/settings/agentcore'
      preLoaderRoute: typeof OrganizationNameSettingsAgentcoreRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/account': {
      id: '/$organizationName/settings/account'
      path: '/account'
      fullPath: '/$organizationName/settings/account'
      preLoaderRoute: typeof OrganizationNameSettingsAccountRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/_access': {
      id: '/$organizationName/settings/_access'
      path: ''
      fullPath: '/$organizationName/settings'
      preLoaderRoute: typeof OrganizationNameSettingsAccessRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/org-docs/$pageVersionNodeId': {
      id: '/$organizationName/org-docs/$pageVersionNodeId'
      path: '/$pageVersionNodeId'
      fullPath: '/$organizationName/org-docs/$pageVersionNodeId'
      preLoaderRoute: typeof OrganizationNameOrgDocsPageVersionNodeIdRouteImport
      parentRoute: typeof OrganizationNameOrgDocsRouteRoute
    }
    '/$organizationName/investigations/new': {
      id: '/$organizationName/investigations/new'
      path: '/new'
      fullPath: '/$organizationName/investigations/new'
      preLoaderRoute: typeof OrganizationNameInvestigationsNewRouteImport
      parentRoute: typeof OrganizationNameInvestigationsRouteRoute
    }
    '/$organizationName/investigations/$investigationId': {
      id: '/$organizationName/investigations/$investigationId'
      path: '/$investigationId'
      fullPath: '/$organizationName/investigations/$investigationId'
      preLoaderRoute: typeof OrganizationNameInvestigationsInvestigationIdRouteImport
      parentRoute: typeof OrganizationNameInvestigationsRouteRoute
    }
    '/$organizationName/_dashboard/sources': {
      id: '/$organizationName/_dashboard/sources'
      path: '/sources'
      fullPath: '/$organizationName/sources'
      preLoaderRoute: typeof OrganizationNameDashboardSourcesRouteImport
      parentRoute: typeof OrganizationNameDashboardRouteRoute
    }
    '/$organizationName/_dashboard/branches': {
      id: '/$organizationName/_dashboard/branches'
      path: '/branches'
      fullPath: '/$organizationName/branches'
      preLoaderRoute: typeof OrganizationNameDashboardBranchesRouteImport
      parentRoute: typeof OrganizationNameDashboardRouteRoute
    }
    '/$organizationName/settings/machines': {
      id: '/$organizationName/settings/machines'
      path: '/machines'
      fullPath: '/$organizationName/settings/machines'
      preLoaderRoute: typeof OrganizationNameSettingsMachinesRouteRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/analytics': {
      id: '/$organizationName/settings/analytics'
      path: '/analytics'
      fullPath: '/$organizationName/settings/analytics'
      preLoaderRoute: typeof OrganizationNameSettingsAnalyticsRouteRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/access-tokens': {
      id: '/$organizationName/settings/access-tokens'
      path: '/access-tokens'
      fullPath: '/$organizationName/settings/access-tokens'
      preLoaderRoute: typeof OrganizationNameSettingsAccessTokensRouteRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/pdf/$pdfVersionNodeId': {
      id: '/$organizationName/pdf/$pdfVersionNodeId'
      path: '/$organizationName/pdf/$pdfVersionNodeId'
      fullPath: '/$organizationName/pdf/$pdfVersionNodeId'
      preLoaderRoute: typeof OrganizationNamePdfPdfVersionNodeIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/cb/$codebaseId': {
      id: '/$organizationName/cb/$codebaseId'
      path: '/$organizationName/cb/$codebaseId'
      fullPath: '/$organizationName/cb/$codebaseId'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/_dashboard/analytics': {
      id: '/$organizationName/_dashboard/analytics'
      path: '/analytics'
      fullPath: '/$organizationName/analytics'
      preLoaderRoute: typeof OrganizationNameDashboardAnalyticsRouteRouteImport
      parentRoute: typeof OrganizationNameDashboardRouteRoute
    }
    '/$organizationName/settings/machines/': {
      id: '/$organizationName/settings/machines/'
      path: '/'
      fullPath: '/$organizationName/settings/machines/'
      preLoaderRoute: typeof OrganizationNameSettingsMachinesIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsMachinesRouteRoute
    }
    '/$organizationName/settings/integrations/': {
      id: '/$organizationName/settings/integrations/'
      path: '/integrations'
      fullPath: '/$organizationName/settings/integrations/'
      preLoaderRoute: typeof OrganizationNameSettingsIntegrationsIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/pdf/$pdfVersionNodeId/': {
      id: '/$organizationName/pdf/$pdfVersionNodeId/'
      path: '/'
      fullPath: '/$organizationName/pdf/$pdfVersionNodeId/'
      preLoaderRoute: typeof OrganizationNamePdfPdfVersionNodeIdIndexRouteImport
      parentRoute: typeof OrganizationNamePdfPdfVersionNodeIdRouteRoute
    }
    '/$organizationName/settings/integrations/agent-connections': {
      id: '/$organizationName/settings/integrations/agent-connections'
      path: '/integrations/agent-connections'
      fullPath: '/$organizationName/settings/integrations/agent-connections'
      preLoaderRoute: typeof OrganizationNameSettingsIntegrationsAgentConnectionsRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/settings/integrations/$integrationType': {
      id: '/$organizationName/settings/integrations/$integrationType'
      path: '/integrations/$integrationType'
      fullPath: '/$organizationName/settings/integrations/$integrationType'
      preLoaderRoute: typeof OrganizationNameSettingsIntegrationsIntegrationTypeRouteImport
      parentRoute: typeof OrganizationNameSettingsRouteRoute
    }
    '/$organizationName/cb/$codebaseId/branches': {
      id: '/$organizationName/cb/$codebaseId/branches'
      path: '/branches'
      fullPath: '/$organizationName/cb/$codebaseId/branches'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdBranchesRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/settings/_access/users': {
      id: '/$organizationName/settings/_access/users'
      path: '/users'
      fullPath: '/$organizationName/settings/users'
      preLoaderRoute: typeof OrganizationNameSettingsAccessUsersRouteRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessRoute
    }
    '/$organizationName/settings/_access/teams': {
      id: '/$organizationName/settings/_access/teams'
      path: '/teams'
      fullPath: '/$organizationName/settings/teams'
      preLoaderRoute: typeof OrganizationNameSettingsAccessTeamsRouteRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessRoute
    }
    '/$organizationName/settings/_access/sources': {
      id: '/$organizationName/settings/_access/sources'
      path: '/sources'
      fullPath: '/$organizationName/settings/sources'
      preLoaderRoute: typeof OrganizationNameSettingsAccessSourcesRouteRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessRoute
    }
    '/$organizationName/pdf/$pdfVersionNodeId/settings': {
      id: '/$organizationName/pdf/$pdfVersionNodeId/settings'
      path: '/settings'
      fullPath: '/$organizationName/pdf/$pdfVersionNodeId/settings'
      preLoaderRoute: typeof OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteImport
      parentRoute: typeof OrganizationNamePdfPdfVersionNodeIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/settings': {
      id: '/$organizationName/cb/$codebaseId/settings'
      path: '/settings'
      fullPath: '/$organizationName/cb/$codebaseId/settings'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdSettingsRouteRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/settings/machines/$machineId/': {
      id: '/$organizationName/settings/machines/$machineId/'
      path: '/$machineId'
      fullPath: '/$organizationName/settings/machines/$machineId/'
      preLoaderRoute: typeof OrganizationNameSettingsMachinesMachineIdIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsMachinesRouteRoute
    }
    '/$organizationName/settings/analytics/$codebaseId/': {
      id: '/$organizationName/settings/analytics/$codebaseId/'
      path: '/$codebaseId'
      fullPath: '/$organizationName/settings/analytics/$codebaseId/'
      preLoaderRoute: typeof OrganizationNameSettingsAnalyticsCodebaseIdIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsAnalyticsRouteRoute
    }
    '/$organizationName/settings/_access/users/': {
      id: '/$organizationName/settings/_access/users/'
      path: '/'
      fullPath: '/$organizationName/settings/users/'
      preLoaderRoute: typeof OrganizationNameSettingsAccessUsersIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessUsersRouteRoute
    }
    '/$organizationName/pdf/$pdfVersionNodeId/autodocs/': {
      id: '/$organizationName/pdf/$pdfVersionNodeId/autodocs/'
      path: '/autodocs'
      fullPath: '/$organizationName/pdf/$pdfVersionNodeId/autodocs/'
      preLoaderRoute: typeof OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRouteImport
      parentRoute: typeof OrganizationNamePdfPdfVersionNodeIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/autodocs/': {
      id: '/$organizationName/cb/$codebaseId/autodocs/'
      path: '/autodocs'
      fullPath: '/$organizationName/cb/$codebaseId/autodocs/'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdAutodocsIndexRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/atlas/': {
      id: '/$organizationName/cb/$codebaseId/atlas/'
      path: '/atlas'
      fullPath: '/$organizationName/cb/$codebaseId/atlas/'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdAtlasIndexRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/_dashboard/analytics/$codebaseId/': {
      id: '/$organizationName/_dashboard/analytics/$codebaseId/'
      path: '/$codebaseId'
      fullPath: '/$organizationName/analytics/$codebaseId/'
      preLoaderRoute: typeof OrganizationNameDashboardAnalyticsCodebaseIdIndexRouteImport
      parentRoute: typeof OrganizationNameDashboardAnalyticsRouteRoute
    }
    '/$organizationName/settings/machines/$machineId/$tab': {
      id: '/$organizationName/settings/machines/$machineId/$tab'
      path: '/$machineId/$tab'
      fullPath: '/$organizationName/settings/machines/$machineId/$tab'
      preLoaderRoute: typeof OrganizationNameSettingsMachinesMachineIdTabRouteImport
      parentRoute: typeof OrganizationNameSettingsMachinesRouteRoute
    }
    '/$organizationName/settings/analytics/$codebaseId/$tab': {
      id: '/$organizationName/settings/analytics/$codebaseId/$tab'
      path: '/$codebaseId/$tab'
      fullPath: '/$organizationName/settings/analytics/$codebaseId/$tab'
      preLoaderRoute: typeof OrganizationNameSettingsAnalyticsCodebaseIdTabRouteImport
      parentRoute: typeof OrganizationNameSettingsAnalyticsRouteRoute
    }
    '/$organizationName/pdf/$pdfVersionNodeId/settings/general': {
      id: '/$organizationName/pdf/$pdfVersionNodeId/settings/general'
      path: '/general'
      fullPath: '/$organizationName/pdf/$pdfVersionNodeId/settings/general'
      preLoaderRoute: typeof OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRouteImport
      parentRoute: typeof OrganizationNamePdfPdfVersionNodeIdSettingsRouteRoute
    }
    '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId': {
      id: '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId'
      path: '/autodocs/$autodocId'
      fullPath: '/$organizationName/pdf/$pdfVersionNodeId/autodocs/$autodocId'
      preLoaderRoute: typeof OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRouteImport
      parentRoute: typeof OrganizationNamePdfPdfVersionNodeIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/tree/$': {
      id: '/$organizationName/cb/$codebaseId/tree/$'
      path: '/tree/$'
      fullPath: '/$organizationName/cb/$codebaseId/tree/$'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdTreeSplatRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/settings/general': {
      id: '/$organizationName/cb/$codebaseId/settings/general'
      path: '/general'
      fullPath: '/$organizationName/cb/$codebaseId/settings/general'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdSettingsGeneralRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdSettingsRouteRoute
    }
    '/$organizationName/cb/$codebaseId/overview/$': {
      id: '/$organizationName/cb/$codebaseId/overview/$'
      path: '/overview/$'
      fullPath: '/$organizationName/cb/$codebaseId/overview/$'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdOverviewSplatRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/code/$': {
      id: '/$organizationName/cb/$codebaseId/code/$'
      path: '/code/$'
      fullPath: '/$organizationName/cb/$codebaseId/code/$'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdCodeSplatRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/autodocs/$autodocId': {
      id: '/$organizationName/cb/$codebaseId/autodocs/$autodocId'
      path: '/autodocs/$autodocId'
      fullPath: '/$organizationName/cb/$codebaseId/autodocs/$autodocId'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdAutodocsAutodocIdRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/atlas/$': {
      id: '/$organizationName/cb/$codebaseId/atlas/$'
      path: '/atlas/$'
      fullPath: '/$organizationName/cb/$codebaseId/atlas/$'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdAtlasSplatRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
    '/$organizationName/_dashboard/analytics/$codebaseId/$tab': {
      id: '/$organizationName/_dashboard/analytics/$codebaseId/$tab'
      path: '/$codebaseId/$tab'
      fullPath: '/$organizationName/analytics/$codebaseId/$tab'
      preLoaderRoute: typeof OrganizationNameDashboardAnalyticsCodebaseIdTabRouteImport
      parentRoute: typeof OrganizationNameDashboardAnalyticsRouteRoute
    }
    '/$organizationName/settings/_access/users/$userId/': {
      id: '/$organizationName/settings/_access/users/$userId/'
      path: '/$userId'
      fullPath: '/$organizationName/settings/users/$userId/'
      preLoaderRoute: typeof OrganizationNameSettingsAccessUsersUserIdIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessUsersRouteRoute
    }
    '/$organizationName/settings/_access/teams/$teamId/': {
      id: '/$organizationName/settings/_access/teams/$teamId/'
      path: '/$teamId'
      fullPath: '/$organizationName/settings/teams/$teamId/'
      preLoaderRoute: typeof OrganizationNameSettingsAccessTeamsTeamIdIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessTeamsRouteRoute
    }
    '/$organizationName/settings/_access/sources/$sourceId/': {
      id: '/$organizationName/settings/_access/sources/$sourceId/'
      path: '/$sourceId'
      fullPath: '/$organizationName/settings/sources/$sourceId/'
      preLoaderRoute: typeof OrganizationNameSettingsAccessSourcesSourceIdIndexRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessSourcesRouteRoute
    }
    '/$organizationName/ws/$workspaceId/cb/$codebaseId/$': {
      id: '/$organizationName/ws/$workspaceId/cb/$codebaseId/$'
      path: '/$organizationName/ws/$workspaceId/cb/$codebaseId/$'
      fullPath: '/$organizationName/ws/$workspaceId/cb/$codebaseId/$'
      preLoaderRoute: typeof OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationName/settings/_access/users/$userId/$tab': {
      id: '/$organizationName/settings/_access/users/$userId/$tab'
      path: '/$userId/$tab'
      fullPath: '/$organizationName/settings/users/$userId/$tab'
      preLoaderRoute: typeof OrganizationNameSettingsAccessUsersUserIdTabRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessUsersRouteRoute
    }
    '/$organizationName/settings/_access/teams/$teamId/$tab': {
      id: '/$organizationName/settings/_access/teams/$teamId/$tab'
      path: '/$teamId/$tab'
      fullPath: '/$organizationName/settings/teams/$teamId/$tab'
      preLoaderRoute: typeof OrganizationNameSettingsAccessTeamsTeamIdTabRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessTeamsRouteRoute
    }
    '/$organizationName/settings/_access/sources/$sourceId/branches': {
      id: '/$organizationName/settings/_access/sources/$sourceId/branches'
      path: '/$sourceId/branches'
      fullPath: '/$organizationName/settings/sources/$sourceId/branches'
      preLoaderRoute: typeof OrganizationNameSettingsAccessSourcesSourceIdBranchesRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessSourcesRouteRoute
    }
    '/$organizationName/settings/_access/sources/$sourceId/$tab': {
      id: '/$organizationName/settings/_access/sources/$sourceId/$tab'
      path: '/$sourceId/$tab'
      fullPath: '/$organizationName/settings/sources/$sourceId/$tab'
      preLoaderRoute: typeof OrganizationNameSettingsAccessSourcesSourceIdTabRouteImport
      parentRoute: typeof OrganizationNameSettingsAccessSourcesRouteRoute
    }
    '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId': {
      id: '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId'
      path: '/autodocs/page/$pageVersionNodeId'
      fullPath: '/$organizationName/pdf/$pdfVersionNodeId/autodocs/page/$pageVersionNodeId'
      preLoaderRoute: typeof OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRouteImport
      parentRoute: typeof OrganizationNamePdfPdfVersionNodeIdRouteRoute
    }
    '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId': {
      id: '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId'
      path: '/autodocs/page/$pageVersionNodeId'
      fullPath: '/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId'
      preLoaderRoute: typeof OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRouteImport
      parentRoute: typeof OrganizationNameCbCodebaseIdRouteRoute
    }
  }
}

interface PublicRouteChildren {
  PublicSignupRoute: typeof PublicSignupRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSignupRoute: PublicSignupRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface OrganizationNameDashboardAnalyticsRouteRouteChildren {
  OrganizationNameDashboardAnalyticsCodebaseIdTabRoute: typeof OrganizationNameDashboardAnalyticsCodebaseIdTabRoute
  OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute: typeof OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute
}

const OrganizationNameDashboardAnalyticsRouteRouteChildren: OrganizationNameDashboardAnalyticsRouteRouteChildren =
  {
    OrganizationNameDashboardAnalyticsCodebaseIdTabRoute:
      OrganizationNameDashboardAnalyticsCodebaseIdTabRoute,
    OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute:
      OrganizationNameDashboardAnalyticsCodebaseIdIndexRoute,
  }

const OrganizationNameDashboardAnalyticsRouteRouteWithChildren =
  OrganizationNameDashboardAnalyticsRouteRoute._addFileChildren(
    OrganizationNameDashboardAnalyticsRouteRouteChildren,
  )

interface OrganizationNameDashboardRouteRouteChildren {
  OrganizationNameDashboardAnalyticsRouteRoute: typeof OrganizationNameDashboardAnalyticsRouteRouteWithChildren
  OrganizationNameDashboardBranchesRoute: typeof OrganizationNameDashboardBranchesRoute
  OrganizationNameDashboardSourcesRoute: typeof OrganizationNameDashboardSourcesRoute
}

const OrganizationNameDashboardRouteRouteChildren: OrganizationNameDashboardRouteRouteChildren =
  {
    OrganizationNameDashboardAnalyticsRouteRoute:
      OrganizationNameDashboardAnalyticsRouteRouteWithChildren,
    OrganizationNameDashboardBranchesRoute:
      OrganizationNameDashboardBranchesRoute,
    OrganizationNameDashboardSourcesRoute:
      OrganizationNameDashboardSourcesRoute,
  }

const OrganizationNameDashboardRouteRouteWithChildren =
  OrganizationNameDashboardRouteRoute._addFileChildren(
    OrganizationNameDashboardRouteRouteChildren,
  )

interface OrganizationNameInvestigationsRouteRouteChildren {
  OrganizationNameInvestigationsInvestigationIdRoute: typeof OrganizationNameInvestigationsInvestigationIdRoute
  OrganizationNameInvestigationsNewRoute: typeof OrganizationNameInvestigationsNewRoute
  OrganizationNameInvestigationsIndexRoute: typeof OrganizationNameInvestigationsIndexRoute
}

const OrganizationNameInvestigationsRouteRouteChildren: OrganizationNameInvestigationsRouteRouteChildren =
  {
    OrganizationNameInvestigationsInvestigationIdRoute:
      OrganizationNameInvestigationsInvestigationIdRoute,
    OrganizationNameInvestigationsNewRoute:
      OrganizationNameInvestigationsNewRoute,
    OrganizationNameInvestigationsIndexRoute:
      OrganizationNameInvestigationsIndexRoute,
  }

const OrganizationNameInvestigationsRouteRouteWithChildren =
  OrganizationNameInvestigationsRouteRoute._addFileChildren(
    OrganizationNameInvestigationsRouteRouteChildren,
  )

interface OrganizationNameOrgDocsRouteRouteChildren {
  OrganizationNameOrgDocsPageVersionNodeIdRoute: typeof OrganizationNameOrgDocsPageVersionNodeIdRoute
  OrganizationNameOrgDocsIndexRoute: typeof OrganizationNameOrgDocsIndexRoute
}

const OrganizationNameOrgDocsRouteRouteChildren: OrganizationNameOrgDocsRouteRouteChildren =
  {
    OrganizationNameOrgDocsPageVersionNodeIdRoute:
      OrganizationNameOrgDocsPageVersionNodeIdRoute,
    OrganizationNameOrgDocsIndexRoute: OrganizationNameOrgDocsIndexRoute,
  }

const OrganizationNameOrgDocsRouteRouteWithChildren =
  OrganizationNameOrgDocsRouteRoute._addFileChildren(
    OrganizationNameOrgDocsRouteRouteChildren,
  )

interface OrganizationNameSettingsAnalyticsRouteRouteChildren {
  OrganizationNameSettingsAnalyticsCodebaseIdTabRoute: typeof OrganizationNameSettingsAnalyticsCodebaseIdTabRoute
  OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute: typeof OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute
}

const OrganizationNameSettingsAnalyticsRouteRouteChildren: OrganizationNameSettingsAnalyticsRouteRouteChildren =
  {
    OrganizationNameSettingsAnalyticsCodebaseIdTabRoute:
      OrganizationNameSettingsAnalyticsCodebaseIdTabRoute,
    OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute:
      OrganizationNameSettingsAnalyticsCodebaseIdIndexRoute,
  }

const OrganizationNameSettingsAnalyticsRouteRouteWithChildren =
  OrganizationNameSettingsAnalyticsRouteRoute._addFileChildren(
    OrganizationNameSettingsAnalyticsRouteRouteChildren,
  )

interface OrganizationNameSettingsMachinesRouteRouteChildren {
  OrganizationNameSettingsMachinesIndexRoute: typeof OrganizationNameSettingsMachinesIndexRoute
  OrganizationNameSettingsMachinesMachineIdTabRoute: typeof OrganizationNameSettingsMachinesMachineIdTabRoute
  OrganizationNameSettingsMachinesMachineIdIndexRoute: typeof OrganizationNameSettingsMachinesMachineIdIndexRoute
}

const OrganizationNameSettingsMachinesRouteRouteChildren: OrganizationNameSettingsMachinesRouteRouteChildren =
  {
    OrganizationNameSettingsMachinesIndexRoute:
      OrganizationNameSettingsMachinesIndexRoute,
    OrganizationNameSettingsMachinesMachineIdTabRoute:
      OrganizationNameSettingsMachinesMachineIdTabRoute,
    OrganizationNameSettingsMachinesMachineIdIndexRoute:
      OrganizationNameSettingsMachinesMachineIdIndexRoute,
  }

const OrganizationNameSettingsMachinesRouteRouteWithChildren =
  OrganizationNameSettingsMachinesRouteRoute._addFileChildren(
    OrganizationNameSettingsMachinesRouteRouteChildren,
  )

interface OrganizationNameSettingsAccessSourcesRouteRouteChildren {
  OrganizationNameSettingsAccessSourcesSourceIdTabRoute: typeof OrganizationNameSettingsAccessSourcesSourceIdTabRoute
  OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute: typeof OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute
  OrganizationNameSettingsAccessSourcesSourceIdIndexRoute: typeof OrganizationNameSettingsAccessSourcesSourceIdIndexRoute
}

const OrganizationNameSettingsAccessSourcesRouteRouteChildren: OrganizationNameSettingsAccessSourcesRouteRouteChildren =
  {
    OrganizationNameSettingsAccessSourcesSourceIdTabRoute:
      OrganizationNameSettingsAccessSourcesSourceIdTabRoute,
    OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute:
      OrganizationNameSettingsAccessSourcesSourceIdBranchesRoute,
    OrganizationNameSettingsAccessSourcesSourceIdIndexRoute:
      OrganizationNameSettingsAccessSourcesSourceIdIndexRoute,
  }

const OrganizationNameSettingsAccessSourcesRouteRouteWithChildren =
  OrganizationNameSettingsAccessSourcesRouteRoute._addFileChildren(
    OrganizationNameSettingsAccessSourcesRouteRouteChildren,
  )

interface OrganizationNameSettingsAccessTeamsRouteRouteChildren {
  OrganizationNameSettingsAccessTeamsTeamIdTabRoute: typeof OrganizationNameSettingsAccessTeamsTeamIdTabRoute
  OrganizationNameSettingsAccessTeamsTeamIdIndexRoute: typeof OrganizationNameSettingsAccessTeamsTeamIdIndexRoute
}

const OrganizationNameSettingsAccessTeamsRouteRouteChildren: OrganizationNameSettingsAccessTeamsRouteRouteChildren =
  {
    OrganizationNameSettingsAccessTeamsTeamIdTabRoute:
      OrganizationNameSettingsAccessTeamsTeamIdTabRoute,
    OrganizationNameSettingsAccessTeamsTeamIdIndexRoute:
      OrganizationNameSettingsAccessTeamsTeamIdIndexRoute,
  }

const OrganizationNameSettingsAccessTeamsRouteRouteWithChildren =
  OrganizationNameSettingsAccessTeamsRouteRoute._addFileChildren(
    OrganizationNameSettingsAccessTeamsRouteRouteChildren,
  )

interface OrganizationNameSettingsAccessUsersRouteRouteChildren {
  OrganizationNameSettingsAccessUsersIndexRoute: typeof OrganizationNameSettingsAccessUsersIndexRoute
  OrganizationNameSettingsAccessUsersUserIdTabRoute: typeof OrganizationNameSettingsAccessUsersUserIdTabRoute
  OrganizationNameSettingsAccessUsersUserIdIndexRoute: typeof OrganizationNameSettingsAccessUsersUserIdIndexRoute
}

const OrganizationNameSettingsAccessUsersRouteRouteChildren: OrganizationNameSettingsAccessUsersRouteRouteChildren =
  {
    OrganizationNameSettingsAccessUsersIndexRoute:
      OrganizationNameSettingsAccessUsersIndexRoute,
    OrganizationNameSettingsAccessUsersUserIdTabRoute:
      OrganizationNameSettingsAccessUsersUserIdTabRoute,
    OrganizationNameSettingsAccessUsersUserIdIndexRoute:
      OrganizationNameSettingsAccessUsersUserIdIndexRoute,
  }

const OrganizationNameSettingsAccessUsersRouteRouteWithChildren =
  OrganizationNameSettingsAccessUsersRouteRoute._addFileChildren(
    OrganizationNameSettingsAccessUsersRouteRouteChildren,
  )

interface OrganizationNameSettingsAccessRouteChildren {
  OrganizationNameSettingsAccessSourcesRouteRoute: typeof OrganizationNameSettingsAccessSourcesRouteRouteWithChildren
  OrganizationNameSettingsAccessTeamsRouteRoute: typeof OrganizationNameSettingsAccessTeamsRouteRouteWithChildren
  OrganizationNameSettingsAccessUsersRouteRoute: typeof OrganizationNameSettingsAccessUsersRouteRouteWithChildren
}

const OrganizationNameSettingsAccessRouteChildren: OrganizationNameSettingsAccessRouteChildren =
  {
    OrganizationNameSettingsAccessSourcesRouteRoute:
      OrganizationNameSettingsAccessSourcesRouteRouteWithChildren,
    OrganizationNameSettingsAccessTeamsRouteRoute:
      OrganizationNameSettingsAccessTeamsRouteRouteWithChildren,
    OrganizationNameSettingsAccessUsersRouteRoute:
      OrganizationNameSettingsAccessUsersRouteRouteWithChildren,
  }

const OrganizationNameSettingsAccessRouteWithChildren =
  OrganizationNameSettingsAccessRoute._addFileChildren(
    OrganizationNameSettingsAccessRouteChildren,
  )

interface OrganizationNameSettingsRouteRouteChildren {
  OrganizationNameSettingsAccessTokensRouteRoute: typeof OrganizationNameSettingsAccessTokensRouteRoute
  OrganizationNameSettingsAnalyticsRouteRoute: typeof OrganizationNameSettingsAnalyticsRouteRouteWithChildren
  OrganizationNameSettingsMachinesRouteRoute: typeof OrganizationNameSettingsMachinesRouteRouteWithChildren
  OrganizationNameSettingsAccessRoute: typeof OrganizationNameSettingsAccessRouteWithChildren
  OrganizationNameSettingsAccountRoute: typeof OrganizationNameSettingsAccountRoute
  OrganizationNameSettingsAgentcoreRoute: typeof OrganizationNameSettingsAgentcoreRoute
  OrganizationNameSettingsBillingRoute: typeof OrganizationNameSettingsBillingRoute
  OrganizationNameSettingsByomRoute: typeof OrganizationNameSettingsByomRoute
  OrganizationNameSettingsLabsRoute: typeof OrganizationNameSettingsLabsRoute
  OrganizationNameSettingsOrganizationRoute: typeof OrganizationNameSettingsOrganizationRoute
  OrganizationNameSettingsSsoScimRoute: typeof OrganizationNameSettingsSsoScimRoute
  OrganizationNameSettingsUsageRoute: typeof OrganizationNameSettingsUsageRoute
  OrganizationNameSettingsWorkspaceRoute: typeof OrganizationNameSettingsWorkspaceRoute
  OrganizationNameSettingsIndexRoute: typeof OrganizationNameSettingsIndexRoute
  OrganizationNameSettingsIntegrationsIntegrationTypeRoute: typeof OrganizationNameSettingsIntegrationsIntegrationTypeRoute
  OrganizationNameSettingsIntegrationsAgentConnectionsRoute: typeof OrganizationNameSettingsIntegrationsAgentConnectionsRoute
  OrganizationNameSettingsIntegrationsIndexRoute: typeof OrganizationNameSettingsIntegrationsIndexRoute
}

const OrganizationNameSettingsRouteRouteChildren: OrganizationNameSettingsRouteRouteChildren =
  {
    OrganizationNameSettingsAccessTokensRouteRoute:
      OrganizationNameSettingsAccessTokensRouteRoute,
    OrganizationNameSettingsAnalyticsRouteRoute:
      OrganizationNameSettingsAnalyticsRouteRouteWithChildren,
    OrganizationNameSettingsMachinesRouteRoute:
      OrganizationNameSettingsMachinesRouteRouteWithChildren,
    OrganizationNameSettingsAccessRoute:
      OrganizationNameSettingsAccessRouteWithChildren,
    OrganizationNameSettingsAccountRoute: OrganizationNameSettingsAccountRoute,
    OrganizationNameSettingsAgentcoreRoute:
      OrganizationNameSettingsAgentcoreRoute,
    OrganizationNameSettingsBillingRoute: OrganizationNameSettingsBillingRoute,
    OrganizationNameSettingsByomRoute: OrganizationNameSettingsByomRoute,
    OrganizationNameSettingsLabsRoute: OrganizationNameSettingsLabsRoute,
    OrganizationNameSettingsOrganizationRoute:
      OrganizationNameSettingsOrganizationRoute,
    OrganizationNameSettingsSsoScimRoute: OrganizationNameSettingsSsoScimRoute,
    OrganizationNameSettingsUsageRoute: OrganizationNameSettingsUsageRoute,
    OrganizationNameSettingsWorkspaceRoute:
      OrganizationNameSettingsWorkspaceRoute,
    OrganizationNameSettingsIndexRoute: OrganizationNameSettingsIndexRoute,
    OrganizationNameSettingsIntegrationsIntegrationTypeRoute:
      OrganizationNameSettingsIntegrationsIntegrationTypeRoute,
    OrganizationNameSettingsIntegrationsAgentConnectionsRoute:
      OrganizationNameSettingsIntegrationsAgentConnectionsRoute,
    OrganizationNameSettingsIntegrationsIndexRoute:
      OrganizationNameSettingsIntegrationsIndexRoute,
  }

const OrganizationNameSettingsRouteRouteWithChildren =
  OrganizationNameSettingsRouteRoute._addFileChildren(
    OrganizationNameSettingsRouteRouteChildren,
  )

interface OrganizationNameCbCodebaseIdSettingsRouteRouteChildren {
  OrganizationNameCbCodebaseIdSettingsGeneralRoute: typeof OrganizationNameCbCodebaseIdSettingsGeneralRoute
}

const OrganizationNameCbCodebaseIdSettingsRouteRouteChildren: OrganizationNameCbCodebaseIdSettingsRouteRouteChildren =
  {
    OrganizationNameCbCodebaseIdSettingsGeneralRoute:
      OrganizationNameCbCodebaseIdSettingsGeneralRoute,
  }

const OrganizationNameCbCodebaseIdSettingsRouteRouteWithChildren =
  OrganizationNameCbCodebaseIdSettingsRouteRoute._addFileChildren(
    OrganizationNameCbCodebaseIdSettingsRouteRouteChildren,
  )

interface OrganizationNameCbCodebaseIdRouteRouteChildren {
  OrganizationNameCbCodebaseIdSettingsRouteRoute: typeof OrganizationNameCbCodebaseIdSettingsRouteRouteWithChildren
  OrganizationNameCbCodebaseIdBranchesRoute: typeof OrganizationNameCbCodebaseIdBranchesRoute
  OrganizationNameCbCodebaseIdAtlasSplatRoute: typeof OrganizationNameCbCodebaseIdAtlasSplatRoute
  OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute: typeof OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute
  OrganizationNameCbCodebaseIdCodeSplatRoute: typeof OrganizationNameCbCodebaseIdCodeSplatRoute
  OrganizationNameCbCodebaseIdOverviewSplatRoute: typeof OrganizationNameCbCodebaseIdOverviewSplatRoute
  OrganizationNameCbCodebaseIdTreeSplatRoute: typeof OrganizationNameCbCodebaseIdTreeSplatRoute
  OrganizationNameCbCodebaseIdAtlasIndexRoute: typeof OrganizationNameCbCodebaseIdAtlasIndexRoute
  OrganizationNameCbCodebaseIdAutodocsIndexRoute: typeof OrganizationNameCbCodebaseIdAutodocsIndexRoute
  OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute: typeof OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute
}

const OrganizationNameCbCodebaseIdRouteRouteChildren: OrganizationNameCbCodebaseIdRouteRouteChildren =
  {
    OrganizationNameCbCodebaseIdSettingsRouteRoute:
      OrganizationNameCbCodebaseIdSettingsRouteRouteWithChildren,
    OrganizationNameCbCodebaseIdBranchesRoute:
      OrganizationNameCbCodebaseIdBranchesRoute,
    OrganizationNameCbCodebaseIdAtlasSplatRoute:
      OrganizationNameCbCodebaseIdAtlasSplatRoute,
    OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute:
      OrganizationNameCbCodebaseIdAutodocsAutodocIdRoute,
    OrganizationNameCbCodebaseIdCodeSplatRoute:
      OrganizationNameCbCodebaseIdCodeSplatRoute,
    OrganizationNameCbCodebaseIdOverviewSplatRoute:
      OrganizationNameCbCodebaseIdOverviewSplatRoute,
    OrganizationNameCbCodebaseIdTreeSplatRoute:
      OrganizationNameCbCodebaseIdTreeSplatRoute,
    OrganizationNameCbCodebaseIdAtlasIndexRoute:
      OrganizationNameCbCodebaseIdAtlasIndexRoute,
    OrganizationNameCbCodebaseIdAutodocsIndexRoute:
      OrganizationNameCbCodebaseIdAutodocsIndexRoute,
    OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute:
      OrganizationNameCbCodebaseIdAutodocsPagePageVersionNodeIdRoute,
  }

const OrganizationNameCbCodebaseIdRouteRouteWithChildren =
  OrganizationNameCbCodebaseIdRouteRoute._addFileChildren(
    OrganizationNameCbCodebaseIdRouteRouteChildren,
  )

interface OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteChildren {
  OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute: typeof OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute
}

const OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteChildren: OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteChildren =
  {
    OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute:
      OrganizationNamePdfPdfVersionNodeIdSettingsGeneralRoute,
  }

const OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteWithChildren =
  OrganizationNamePdfPdfVersionNodeIdSettingsRouteRoute._addFileChildren(
    OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteChildren,
  )

interface OrganizationNamePdfPdfVersionNodeIdRouteRouteChildren {
  OrganizationNamePdfPdfVersionNodeIdSettingsRouteRoute: typeof OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteWithChildren
  OrganizationNamePdfPdfVersionNodeIdIndexRoute: typeof OrganizationNamePdfPdfVersionNodeIdIndexRoute
  OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute: typeof OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute
  OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute: typeof OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute
  OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute: typeof OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute
}

const OrganizationNamePdfPdfVersionNodeIdRouteRouteChildren: OrganizationNamePdfPdfVersionNodeIdRouteRouteChildren =
  {
    OrganizationNamePdfPdfVersionNodeIdSettingsRouteRoute:
      OrganizationNamePdfPdfVersionNodeIdSettingsRouteRouteWithChildren,
    OrganizationNamePdfPdfVersionNodeIdIndexRoute:
      OrganizationNamePdfPdfVersionNodeIdIndexRoute,
    OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute:
      OrganizationNamePdfPdfVersionNodeIdAutodocsAutodocIdRoute,
    OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute:
      OrganizationNamePdfPdfVersionNodeIdAutodocsIndexRoute,
    OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute:
      OrganizationNamePdfPdfVersionNodeIdAutodocsPagePageVersionNodeIdRoute,
  }

const OrganizationNamePdfPdfVersionNodeIdRouteRouteWithChildren =
  OrganizationNamePdfPdfVersionNodeIdRouteRoute._addFileChildren(
    OrganizationNamePdfPdfVersionNodeIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  PublicRoute: PublicRouteWithChildren,
  LogoutRoute: LogoutRoute,
  OrganizationNameDashboardRouteRoute:
    OrganizationNameDashboardRouteRouteWithChildren,
  OrganizationNameInvestigationsRouteRoute:
    OrganizationNameInvestigationsRouteRouteWithChildren,
  OrganizationNameOrgDocsRouteRoute:
    OrganizationNameOrgDocsRouteRouteWithChildren,
  OrganizationNameSettingsRouteRoute:
    OrganizationNameSettingsRouteRouteWithChildren,
  OrganizationNameAboutYouRoute: OrganizationNameAboutYouRoute,
  OrganizationNameLibraryRoute: OrganizationNameLibraryRoute,
  OrganizationNameMcpRoute: OrganizationNameMcpRoute,
  OrganizationNameUsageRoute: OrganizationNameUsageRoute,
  InvestigationsInvestigationIdRoute: InvestigationsInvestigationIdRoute,
  OrganizationNameIndexRoute: OrganizationNameIndexRoute,
  OrganizationNameCbCodebaseIdRouteRoute:
    OrganizationNameCbCodebaseIdRouteRouteWithChildren,
  OrganizationNamePdfPdfVersionNodeIdRouteRoute:
    OrganizationNamePdfPdfVersionNodeIdRouteRouteWithChildren,
  OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute:
    OrganizationNameWsWorkspaceIdCbCodebaseIdSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
